import {Route, Routes, useLocation} from "react-router-dom";
import Header from "./Header";
import Home from "./Home";
import Menu from './Menu';
import Footer from './Footer';
import Login from "./Login";
import Register from "./Register";
import News from "./masters/News";
import ToDo from "./workflow/ToDo";
import AddLandOwner from "./land/AddLandOwner";
import AdminWorkTasks from "./admin/AdminWorkTasks";
import AdminDisputes from "./admin/AdminDisputes";
import OwnerDashboard from "./land/OwnerDashboard";
import OwnerAssignments from "./land/OwnerAssignments";
import OwnerPayments from "./land/OwnerPayments";
import OwnerDisputes from "./land/OwnerDisputes";
import OwnerAttendanceVerification from "./land/OwnerAttendanceVerification";
import AddWorker from "./worker/AddWorker";
import AddLandRequirement from "./land/AddLandRequirement";
import ApplyWork from "./worker/ApplyWork";
import WorkerTasks from "./worker/WorkerTasks";
import WorkerDashboard from "./worker/WorkerDashboard";
import WorkerAttendance from "./worker/WorkerAttendance";
import WorkerPayments from "./worker/WorkerPayments";
import WorkerDisputes from "./worker/WorkerDisputes";
import CropCategory from "./masters/CropCategory";
import Crop from "./masters/Crop";
import CropVariety from "./masters/CropVariety";
import Farmland from "./land/Farmland";
import LandCrop from "./land/LandCrop";
import WorkerRating from "./worker/WorkerRating";
import WorkerNotification from "./worker/WorkerNotification";
import PurchaseRequest from "./procurement/PurchaseRequest";
import PurchaseRequestPrint from "./procurement/PurchaseRequestPrint";
import RFQ from "./procurement/RFQ";
import PurchaseOrder from "./procurement/PurchaseOrder";
import PurchaseOrderPrint from "./procurement/PurchaseOrderPrint";
import SupplierQuotation from "./procurement/SupplierQuotation";
import SupplierQuotationPrint from "./procurement/SupplierQuotationPrint";
import VendorPayment from "./procurement/VendorPayment";
import VendorPaymentPrint from "./procurement/VendorPaymentPrint";
import PurchaseReturn from "./procurement/PurchaseReturn";
import InventoryItem from "./inventory/InventoryItem";
import InventoryCategory from "./inventory/InventoryCategory";
import InventoryTransfer from "./inventory/InventoryTransfer";
import StockTransaction from "./inventory/StockTransaction";
import InventoryTransferItem from "./inventory/InventoryTransferItem";
import InventoryAdjustment from "./inventory/InventoryAdjustment";
import Warehouse from "./warehouse/Warehouse";
import WarehouseBin from "./warehouse/WarehouseBin";
import WarehouseStock from "./warehouse/WarehouseStock";
import GoodsReceipt from "./warehouse/GoodsReceipt";
import GoodsReceiptItem from "./warehouse/GoodsReceiptItem";
import GoodsIssue from "./warehouse/GoodsIssue";
import GoodsIssueItem from "./warehouse/GoodsIssueItem";
import MachineCategory from "./machine/MachineCategory";
import Machine from "./machine/Machine";
import MachineBooking from "./machine/MachineBooking";
import MachineUsage from "./machine/MachineUsage";
import MachinePayment from "./machine/MachinePayment";
import MachineImage from "./machine/MachineImage";
import Workflow from "./workflow/Workflow";
import WorkflowStage from "./workflow/WorkflowStage";
import ApprovalQueue from "./workflow/ApprovalQueue";
import WorkflowTransaction from "./workflow/WorkflowTransaction";
import WorkflowHistory from "./workflow/WorkflowHistory";
import MyRequests from "./workflow/MyRequests";
import Notification from "./notification/Notification";
import Document from "./documents/Document";
import AuditLog from "./audit/AuditLog";
import AIChat from "./analytics/AIChat";
import AIPrompt from "./analytics/AIPrompt";
import AIAgent from "./analytics/AIAgent";
import AIModel from "./analytics/AIModel";
import AIProvider from "./analytics/AIProvider";
import AIPrediction from "./analytics/AIPrediction";

import IoTMenu from './IoT/IoTMenu';
import IoTDevices from './IoT/IoTDevice';
import IoTDeviceForm from './IoT/IoTDeviceForm';

import IoTGateways from './IoT/IoTGateways';
import IoTGatewayForm from './IoT/IoTGatewayForm';

import IoTDeviceMapping from './IoT/IoTDeviceMapping';

import IoTLiveMonitoring from './IoT/IoTLiveMonitoring';

import IoTPatientVitals from './IoT/IoTPatientVitals';

import IoTAlarms from './IoT/IoTAlarms';

import SensorReading from "./analytics/SensorReading";
import AnalyticsReport from "./analytics/AnalyticsReport";
import KPI from "./analytics/KPI";
import PrivateRoute from "./PrivateRoute";
import {AuthProvider} from './context/AuthContext';
import UserProfile from "./masters/UserProfile";
function Main() {
    const location = useLocation();
    const showHeader = location.pathname !== "/user-login";
    return (<div className="App">
        <AuthProvider>

            {showHeader && <Header/>}
           
            <Routes>
                {/* PUBLIC */}
                <Route path="/user-login" element={<Login/>}/>
                <Route path="/user-register" element={<Register/>}/>
                <Route path="/admin-menu" element={<Menu/>}/>

                {/* ADMIN */}
                <Route element={<PrivateRoute allowedRoles={['Admin']}/>}>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/news" element={<News/>}/>
                    <Route path="/todo" element={<ToDo/>}/>
                    <Route path="/user-create" element={<UserProfile/>}/>

                    <Route
                        path="/crop-category"
                        element={<CropCategory/>}
                    />
                    <Route
                        path="/crop"
                        element={<Crop/>}
                    />
                    <Route
                        path="/crop-variety"
                        element={<CropVariety/>}
                    />
                    <Route
                        path="/farmland"
                        element={<Farmland/>}
                    />
                    <Route path="/land-crop" element={<LandCrop/>}/>
                    <Route path="/admin-task" element={<AdminWorkTasks/>}/>
                    <Route path="/admin-dispute" element={<AdminDisputes/>}/>
                    <Route
                        path="/workflow"
                        element={<Workflow/>}
                    />
                    <Route
                        path="/workflow-stage"
                        element={<WorkflowStage/>}
                    />
                    <Route
                        path="/approval-queue"
                        element={<ApprovalQueue/>}
                    />
                    <Route

                        path="/workflow-transaction"

                        element={<WorkflowTransaction/>}

                    />
                    <Route

                        path="/workflow-history"

                        element={<WorkflowHistory/>}

                    />
                    <Route

                        path="/my-requests"

                        element={<MyRequests/>}

                    />
                    <Route

                        path="/notification"

                        element={<Notification/>}

                    />
                    <Route

                        path="/documents"

                        element={<Document/>}

                    />
                    <Route

                        path="/audit-log"

                        element={<AuditLog/>}

                    />
                    <Route
                        path="/ai-model"
                        element={<AIModel/>}
                    />
                    <Route
                        path="/ai-agent"
                        element={<AIAgent/>}
                    />
                    <Route
                        path="/ai-prompt"
                        element={<AIPrompt/>}
                    />
                    <Route

                        path="/ai-prediction"

                        element={<AIPrediction/>}

                    />
                                        <Route

                        path="/ai-provider"

                        element={<AIProvider/>}

                    />

{/* ============================================================
    DRHIS IoT
============================================================ */}

<Route
    path="/iot-menu"
    element={<IoTMenu/>}
/>

<Route
    path="/iot-gateways"
    element={<IoTGateways/>}
/>

<Route
    path="/iot-gateway-form"
    element={<IoTGatewayForm/>}
/>

<Route
    path="/iot-gateway-form/:id"
    element={<IoTGatewayForm/>}
/>

<Route
    path="/iot-devices"
    element={<IoTDevices/>}
/>

<Route
    path="/iot-device-form"
    element={<IoTDeviceForm/>}
/>

<Route
    path="/iot-device-form/:id"
    element={<IoTDeviceForm/>}
/>

<Route
    path="/iot-device-mapping"
    element={<IoTDeviceMapping/>}
/>

<Route
    path="/iot-live-monitoring"
    element={<IoTLiveMonitoring/>}
/>

<Route
    path="/iot-patient-vitals/:patient_id"
    element={<IoTPatientVitals/>}
/>

<Route
    path="/iot-alarms"
    element={<IoTAlarms/>}
/>

                    <Route

                        path="/sensor-reading"

                        element={<SensorReading/>}

                    />
                    <Route

                        path="/analytics-report"

                        element={<AnalyticsReport/>}

                    />
                    <Route

                        path="/kpi"

                        element={<KPI/>}

                    />
                </Route>

                {/* LAND OWNER */}
                <Route element={<PrivateRoute allowedRoles={['Admin', 'LandOwner']}/>}>
                    <Route path="/land-owner" element={<AddLandOwner/>}/>

                    <Route path="/owner-dispute" element={<OwnerDisputes/>}/>
                    <Route path="/owner-dashboard" element={<OwnerDashboard/>}/>
                    <Route
                        path="/owner-assignments"
                        element={<OwnerAssignments/>}
                    />
                    <Route
                        path="/owner-attendance"
                        element={<OwnerAttendanceVerification/>}
                    />
                    <Route
                        path="/owner-payments"
                        element={<OwnerPayments/>}
                    />
                    <Route path="/post-requirement" element={<AddLandRequirement/>}/>
                    <Route
                        path="/purchase-request"
                        element={<PurchaseRequest/>}
                    />
                    <Route
                        path="/purchase-request-print/:id"
                        element={<PurchaseRequestPrint/>}
                    />
                    <Route
                        path="/purchase-order-print/:id"
                        element={<PurchaseOrderPrint/>}
                    />
                    <Route
                        path="/rfq"
                        element={<RFQ/>}
                    />
                    <Route
                        path="/supplier-quotation-print/:id"
                        element={<SupplierQuotationPrint/>}
                    />
                    <Route

                        path="/purchase-order"

                        element={<PurchaseOrder/>}

                    />
                    <Route
                        path="/supplier-quotation"
                        element={<SupplierQuotation/>}
                    />
                    <Route

                        path="/vendor-payment"

                        element={<VendorPayment/>}

                    />
                    <Route
                        path="/vendor-payment-print/:id"
                        element={<VendorPaymentPrint/>}
                    />
                    <Route

                        path="/purchase-return"

                        element={<PurchaseReturn/>}

                    />
                    <Route
                        path="/inventory-item"
                        element={<InventoryItem/>}
                    />

                    <Route

                        path="/inventory-category"

                        element={<InventoryCategory/>}

                    />

                    <Route

                        path="/stock-transaction"

                        element={<StockTransaction/>}

                    />
                    <Route

                        path="/inventory-transfer"

                        element={<InventoryTransfer/>}

                    />
                    <Route

                        path="/inventory-transfer-item"

                        element={<InventoryTransferItem/>}

                    />
                    <Route
                        path="/inventory-adjustment"
                        element={<InventoryAdjustment/>}
                    />
                    <Route
                        path="/warehouse"
                        element={<Warehouse/>}
                    />
                    <Route
                        path="/warehouse-bin"
                        element={<WarehouseBin/>}
                    />
                    <Route
                        path="/warehouse-stock"
                        element={<WarehouseStock/>}
                    />
                    <Route
                        path="/goods-receipt"
                        element={<GoodsReceipt/>}
                    />
                    <Route
                        path="/goods-receipt-item"
                        element={<GoodsReceiptItem/>}
                    />
                    <Route
                        path="/goods-issue"
                        element={<GoodsIssue/>}
                    />
                    <Route
                        path="/goods-issue-item"
                        element={<GoodsIssueItem/>}
                    />
                    <Route
                        path="/machine-category"
                        element={<MachineCategory/>}
                    />
                    <Route
                        path="/machine"
                        element={<Machine/>}
                    />
                    <Route
                        path="/machine-booking"
                        element={<MachineBooking/>}
                    />
                    <Route
                        path="/machine-usage"
                        element={<MachineUsage/>}
                    />
                    <Route
                        path="/machine-payment"
                        element={<MachinePayment/>}
                    />
                    <Route
                        path="/machine-image"
                        element={<MachineImage/>}
                    />


                </Route>

                {/* WORKER */}
                <Route element={<PrivateRoute allowedRoles={['Admin', 'Worker']}/>}>
                    <Route path="/worker" element={<AddWorker/>}/>
                    <Route path="/apply-work" element={<ApplyWork/>}/>
                    <Route path="/work-task" element={<WorkerTasks/>}/>
                    <Route path="/worker-dashboard" element={<WorkerDashboard/>}/>
                    <Route
                        path="/worker-attendance/:assignmentId"
                        element={<WorkerAttendance/>}
                    />
                    <Route
                        path="/worker-payments/:assignmentId"
                        element={<WorkerPayments/>}
                    />
                    <Route
                        path="/worker-disputes/:assignmentId"
                        element={<WorkerDisputes/>}
                    />
                    <Route path="/worker-rating" element={<WorkerRating/>}/>

                    <Route
                        path="/worker-notification"
                        element={<WorkerNotification/>}
                    />
                </Route>

            </Routes>
 {localStorage.getItem("user_login") === "true" && (<>

                <AIChat/>
                <Footer/>
            </>)}
        </AuthProvider>
    </div>);
}
export default Main;
